/** @format */

import {format} from 'date-fns';

import i18n from '../../../../i18n';
import {TRANSLATION_KEY_PREFIX} from '../constants';

export const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const datePart = format(date, 'dd.MM.yyyy');
    const timePart = format(date, 'HH:mm');
    return `${datePart}\n${timePart}`;
  } catch {
    return dateString;
  }
};

export const translateKey = (key: string): string => {
  const translationKey = `${TRANSLATION_KEY_PREFIX}.${key}`;
  const translatedKey = i18n.t(translationKey);
  return translatedKey !== translationKey ? translatedKey : key;
};

export const formatValue = (value: any) => {
  if (!value) return '';

  const extractedData = extractValuesFromJson(value);

  if (extractedData.length === 0) return '';

  return extractedData
    .map(({key, values}) => {
      const translatedKey = translateKey(key);
      return `${translatedKey}: ${values.join(', ')}`;
    })
    .join('\n');
};

const extractValuesFromJson = (jsonValue: any): {key: string; values: string[]}[] => {
  if (!jsonValue) return [];

  let parsedValue;
  try {
    parsedValue = typeof jsonValue === 'string' ? JSON.parse(jsonValue) : jsonValue;
  } catch {
    return [{key: '', values: [String(jsonValue)]}];
  }

  if (!parsedValue || typeof parsedValue !== 'object') {
    return [{key: '', values: [String(parsedValue)]}];
  }

  const result: {key: string; values: string[]}[] = [];

  Object.entries(parsedValue).forEach(([key, value]) => {
    const values: string[] = [];

    if (Array.isArray(value)) {
      if (value.length > 0) {
        values.push(...value.map(item => String(item)));
      } else {
        values.push('пусто');
      }
    } else if (value === null) {
      values.push('не задано');
    } else if (value !== undefined) {
      values.push(String(value));
    }

    result.push({key, values});
  });

  return result;
};
